import TourActions from "./constants";
import { ITourInterface, IActionObject } from "./types";

const INITIAL_STATE: ITourInterface = {
  lastCompletedStep: 0,
  requiresGDPRCompliance: false,
  instId: null,
  locId: null,
  userkey: null,
  sessionid: null,
  tourid: null,
  platform: "w",
  source: "web",
  originalSource: "web",
  oncampus: false,
  testing: false,
  isHover: false,
  isStandalone: false,
  embedType: "virtual-tour",
  fromSearch: false,
  title: "",
  isEmbedded: false,
  isLoading: true,
  linkParams: {
    stopid: "",
    media: "",
  },
};

export default function tourReducer(
  state = INITIAL_STATE,
  action: IActionObject
): ITourInterface {
  switch (action.type) {
    case TourActions.SET_TOUR_PARAMS:
      return { ...state, ...action.data.tour };
    default:
      return state;
  }
}
